<template src="./TimeLineDocumentos.html"> </template>

<script>
import {leerArchivo} from "../../../apiService/request/CrudDocumentos";
import moment from "moment";
export default {
  name: "time-line-documentos",
  data() {
    return {
      limite: 20,
      opcionesSeleccionadas: [],
    };
  },
  created () {
    this.$store.dispatch("setLimiteConsultaDocumentos", this.limite);
    this.$store.dispatch("setFiltrosConsultaDocumentos", this.opcionesSeleccionadas);
  },
  beforeDestroy() {
    this.$store.dispatch("setLimiteConsultaDocumentos", 20);
    this.$store.dispatch("setFiltrosConsultaDocumentos", null);
  },
  computed: {
    /**
     * Permite generar la lista de opciones para el filtrado
     */
    listaDeOpciones() {
      const ultimasOpciones = []
      if(this.opciones && this.opciones.length >= 1) {
        const opcionesFiltradas =this.opciones.reduce(function(r, k) {
          if(k.opciones_lista) {
            ultimasOpciones.push(k.opciones_lista[k.opciones_lista.length - 1]);
            const opciones_lista = k.opciones_lista.splice(0, k.opciones_lista.length - 1);
            r = [...r, ...opciones_lista];
          }
          return r;
        }, []);
        return [...opcionesFiltradas, ...ultimasOpciones];
      }
      return [];
    },
  },
  props: {
    banderaConsultando: {
      type: Boolean,
      default: true
    },
    opciones: {
      type: Array,
      default: () => []
    },
    documentos: {
      type: Array,
      default: () => []
    },
  },
  filters: {
      formatoFechaHora: function (date) {
        return moment(date).format("MMMM Do YYYY, h:mm:ss a");
      }
    },
  methods: {
    consultarDocumentosFiltrados() {
      
      this.$emit("consultarDocumentosFiltrados");
    },
    async mostrarImage(docId) {
      try{
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerArchivo({docId});
        if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.url) {
          window.open(respuesta.data.data.url);
        }
      } catch (err) {
        this.$store.dispatch("setCargando", false);
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    }
  },
  watch: {
    opcionesSeleccionadas(newValue, oldValue) {
        this.$store.dispatch("setFiltrosConsultaDocumentos", newValue);
    },
    limite(newValue, oldValue) {
        this.$store.dispatch("setLimiteConsultaDocumentos", newValue);
    }
  }
};
</script>

<style lang="scss" src="./TimeLineDocumentos.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/TimeLine/TimeLineDocumentos/TimeLineDocumentos.vue